export default __webpack_public_path__ + "static/media/sbu-2021-m700b-galleryimages-7-210129.eb53109c.jpg";